/*
    services.ts

    ON LOCAL SERVER: Must edit middleware.go line 23: AllowOrigins: "*",

    These API calls are made via the fetchjson.ts GET, POST, PUT and DELETE calls
    use ENDPOINTS.functionName to access the URLs and include body if needed.

*/
import { fetchGet, fetchPost, fetchGetWithToken } from './fetcher';
import getBindings from '../../config.js';
import { OPEN_ELIG_2022 } from '../common/taxonomy-classes.js';
import { getTokenRedirect } from "../common/auth";
import { fetchJson, handleToken, METHOD, normalized, publicGet } from "./fetchjson";
// import FAKE_DEMOGRAPHICS from "../common/fake-demographics.js";
// import FAKE_OPEN_ELIG_2022 from "../common/fake-open-eligibility-2022.js";
// import FAKE_PUBLIC_RESULTS from "../common/fake-public-results.js";
import FAKE_COLLECTIONS from "../common/fake-data/fake-collections.js";
const bindings = getBindings();
// convenience func
// 11/21 - moved to fetcher.js to avoid circular reference
// export const getConnectToken = async () => {
//     let token = await getAPIToken(APIs.connectAPI);
//     // console.log("getConnectToken() returns ", token)
//     token = token ?? "";
//     return token
// }
// const getTcareConnectApiToken = () => {
//     return 'Bearer ' + getSessionIdToken();     // or getSessionAccessToken()
// }
// convenience function
const getTcareConnectIntakeToken = async () => {
    let token = await getAPIToken(APIs.connectIntakeAPI);
    token = token !== null && token !== void 0 ? token : "";
    return 'Bearer ' + token; // or getSessionAccessToken()
};
// convenience function
export const getAPIToken = (api) => {
    return getTokenRedirect({
        scopes: api.scopes,
        forceRefresh: false
    });
};
export const APIs = {
    connectAPI: {
        host: bindings.connectAPI.host,
        scopes: bindings.connectAPI.scopes
    },
    connectIntakeAPI: {
        host: bindings.connectAPI.host,
        scopes: bindings.connectAPI.scopes
    }
};
// list all needed endpoints here in one place - CHANGE THEM HERE IF NEEDED!
const ENDPOINTS = {
    // RPC endpoints
    // called once at startup
    fetchTaxonomies: bindings.tcareConnectApi + '/api/v1/rpc/taxonomy-forest',
    // include body - need postalCode!
    searchServices: bindings.tcareConnectApi + '/api/v2/rpc/search',
    // include userId
    fetchDislikes: bindings.tcareConnectApi + '/api/v1/rpc/dislikes',
    // REST endpoints
    // include serviceId        
    fetchServiceById: bindings.tcareConnectApi + '/api/v1/rest/services/',
    // downvote
    createDislike: bindings.tcareConnectApi + '/api/v1/rest/search-feedback',
    // Reviews
    fetchReviews: bindings.tcareConnectApi + '/api/v1/rest/reviews/read',
    // fetchReviews:               'https://tce-connect-intake-dev-func-app.azurewebsites.net/intake/reviewreader',     // same as above
    // fetchReviews:               'https://connect-intake-dev.tailoredcare.org/intake/reviewreader',
    approveReviews: bindings.tcareConnectApi + '/api/v1/rest/reviews/approve',
    // approveReviews:             'https://connect-intake-dev.tailoredcare.org/intake/reviewapprove',
    rejectReviews: bindings.tcareConnectApi + '/api/v1/rest/reviews/reject',
    // rejectReviews:             'https://connect-intake-dev.tailoredcare.org/intake/reviewreject',
    flagDuplicateReviews: bindings.tcareConnectApi + '/api/v1/rest/reviews/submit',
    // Direct Create / Request Update - include JSON payload
    requestCreateService: bindings.tcareConnectApi + '/api/v1/rest/reviews/submit',
    requestUpdateService: bindings.tcareConnectApi + '/api/v1/rest/reviews/submit',
    // api/v1/rest/services/bulk
    fetchBulkServices: bindings.tcareConnectApi + '/api/v1/rest/services/bulk',
    // PUBLIC APIs
    // the non-auth public calls - include the "public" path
    publicFetchTaxonomies: bindings.tcareConnectApi + '/api/public/v1/rpc/taxonomy-forest',
    publicFetchServiceById: bindings.tcareConnectApi + '/api/public/v1/rest/services/',
    publicSearchServices: bindings.tcareConnectApi + '/api/public/v2/rpc/search',
    // 08/01 - now using user collections
    addServicesToCollection: bindings.tcareConnectApi + '/api/public/v1/rpc/???',
    fetchUserCollections: bindings.tcareConnectApi + '/api/public/v1/rpc/???',
    // 09/01 - populate form field with default values
    // the 'endpoint' will be passed in - e.g. 'supported-languages'
    fetchFieldPresetValues: bindings.tcareConnectApi + '/api/v1/rest/',
    // new 10/27/2022 - Notes and Ratings
    fetchNotes: bindings.tcareConnectApi + '/api/v2/rest/fetch-notes',
    createNote: bindings.tcareConnectApi + '/api/v2/rest/create-note',
    updateNote: bindings.tcareConnectApi + '/api/v2/rest/update-note',
    deleteNote: bindings.tcareConnectApi + '/api/v2/rest/delete-note',
    fetchRatings: bindings.tcareConnectApi + '/api/v2/rest/fetch-ratings',
    createRating: bindings.tcareConnectApi + '/api/v2/rest/create-rating',
    updateRating: bindings.tcareConnectApi + '/api/v2/rest/update-rating',
    deleteRating: bindings.tcareConnectApi + '/api/v2/rest/delete-rating',
    // Referrals
    fetchReferralByServiceId: bindings.tcareConnectApi + '/api/v2/???',
    publicFetchReferralByServiceId: bindings.tcareConnectApi + '/api/v2/???',
    // 11/24 - Saved Services
    savedServices: bindings.tcareConnectApi + '/api/v1/rest/saved-services'
};
const logRequestInfo = (url, body = null) => {
    console.log('Request Info:');
    console.log(url);
    if (body)
        console.log(body);
};
export const dedupeArray = (arr, prop) => {
    // console.log('services.ts - dedupeArray');
    const list = [];
    const cleaned = [];
    for (const elem of arr) {
        if (!list.includes(elem[prop])) {
            list.push(elem[prop]);
            cleaned.push(elem);
        }
    }
    // console.log(cleaned);
    return cleaned;
};
// API calls
// POST http://localhost:3000/api/v2/rpc/search/
export const searchServices = async (searchBody) => {
    const url = ENDPOINTS.searchServices;
    const headers = null;
    // logRequestInfo(url, searchBody);
    const json = await fetchPost(url, headers, searchBody);
    // console.log('searchServices raw json:')
    // console.log(json)
    return json; // may be an error
};
export const searchServices2 = async (searchBody) => {
    let url = ENDPOINTS.searchServices;
    let headers = null;
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson('POST', url, headers, searchBody, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        // return {errors: [{message: 'Exception thrown while fetching data.'}]};
        return { errors: [{ message: err }] };
    });
    return normalized(json);
};
// GET http://127.0.0.1:3000/api/v1/rest/services/:id
export const fetchServiceById = async (id) => {
    const url = ENDPOINTS.fetchServiceById + id;
    // logRequestInfo(url);
    const json = await fetchGet(url);
    return json; // may be an error
};
export const fetchServiceById2 = async (id) => {
    //console.log('fetchServiceById2');
    const url = ENDPOINTS.fetchServiceById + id;
    let headers = null;
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, headers, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// this call MUST be public
// GET http://127.0.0.1:3000/api/v1/rpc/taxonomy-forest
export const fetchTaxonomies = async () => {
    const url = ENDPOINTS.fetchTaxonomies;
    // logRequestInfo(url);
    const json = await fetchGet(url);
    if (json[OPEN_ELIG_2022]) {
        json[OPEN_ELIG_2022] = dedupeArray(json[OPEN_ELIG_2022], 'label');
    }
    return json;
};
export const fetchTaxonomies2 = async () => {
    let url = ENDPOINTS.fetchTaxonomies;
    // logRequestInfo(url);
    const json = normalized(await publicGet(url));
    if (json[OPEN_ELIG_2022]) {
        json[OPEN_ELIG_2022] = dedupeArray(json[OPEN_ELIG_2022], 'label');
    }
    return json;
};
// POST http://127.0.0.1:3000/api/v1/rest/search-feedback
// {
//     "searchContext": "",
//     "cookie": "andy",
//     "userId": "1",
//     "serviceId": "1",
//     "reasonForFeedback": ""
// }
export const createDislike = async (params) => {
    const url = ENDPOINTS.createDislike;
    // Vito - hardcoded for now! REMOVE THIS!!!
    const body = {
        "searchContext": "elderly",
        "cookie": "andy",
        "serviceId": 1234,
        "reasonForFeedback": "reason"
    };
    const json = await fetchPost(url, null, body);
    return json;
};
export const createDislike2 = async (params) => {
    const url = ENDPOINTS.createDislike;
    // Vito - hardcoded for now! REMOVE THIS!!!
    const body = {
        "searchContext": "elderly",
        "cookie": "andy",
        "serviceId": 1234,
        "reasonForFeedback": "reason"
    };
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// POST http://127.0.0.1:3000/api/v1/rpc/dislikes
// {
//     "cookie": "<env>+<user-id>"
// }
export const fetchDislikes = async (params) => {
    const url = ENDPOINTS.fetchDislikes;
    const headers = null;
    const body = params;
    const json = await fetchPost(url, headers, body);
    return json;
};
//todo vjm
export const fetchDislikes2 = async (params) => {
    const url = ENDPOINTS.fetchDislikes;
    const headers = null;
    const body = params;
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// 5/26 - API calls for the Review Page (Intake Queue)
// POST /intake/reviewreader 
// { "size": 100 }    
export const fetchReviews = async (size, reviewType) => {
    const url = ENDPOINTS.fetchReviews;
    const headers = null;
    const body = {
        "size": size,
        "reviewType": reviewType
    };
    // logRequestInfo(url, body);
    const json = await fetchPost(url, headers, body);
    return json;
};
// POST /intake/reviewreader
// { "size": 100 }
export const fetchReviews2 = async (size, reviewType, mostRecent) => {
    const url = ENDPOINTS.fetchReviews;
    const headers = null;
    const body = {
        "size": size,
        "reviewType": reviewType,
        "mostRecent": mostRecent,
    };
    // logRequestInfo(url, body);
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// POST /intake/reviewapprove                 // can include up too 100 ids:
// {"ids": ["abc123","bcd123"] }
// 8/23 - THIS API HAS CHANGED - UPDATE may now include updated service in body
// approveReviews:             'https://connect-intake-dev.tailoredcare.org/intake/reviewapprove',
export const approveReviews = async (body) => {
    const url = ENDPOINTS.approveReviews;
    const headers = null;
    // logRequestInfo(url, body);
    const json = await fetchPost(url, headers, body);
    return json;
};
export const approveReviews2 = async (body) => {
    const url = ENDPOINTS.approveReviews;
    const headers = null;
    // logRequestInfo(url, body);
    const json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// POST /intake/reviewreject                  // can include up too 100 ids:
// {"ids": ["abc123","bcd123"] }
export const rejectReviews = async (body) => {
    const url = ENDPOINTS.rejectReviews;
    const headers = null;
    // logRequestInfo(url, body);
    // const json = {errors: 'not implemented yet'};
    const json = await fetchPost(url, headers, body);
    return json;
};
export const rejectReviews2 = async (body) => {
    const url = ENDPOINTS.rejectReviews;
    const headers = null;
    // logRequestInfo(url, body);
    // const json = {errors: 'not implemented yet'};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
export const flagDuplicateReviews = async (reviewIds) => {
    const url = ENDPOINTS.flagDuplicateReviews;
    const headers = null;
    // const headers = {
    //     'Content-Type': 'application/json',
    //     'Authorization': getTcareConnectIntakeToken()       // ??? why intake token?
    // };
    const body = {
        'leftServiceIds': reviewIds
    };
    // logRequestInfo(url, body);
    // const json = {errors: 'not implemented yet'};        // test only
    const json = await fetchPost(url, headers, body);
    return json;
};
export const flagDuplicateReviews2 = async (reviewIds) => {
    const url = ENDPOINTS.flagDuplicateReviews;
    const headers = null;
    // const headers = {
    //     'Content-Type': 'application/json',
    //     'Authorization': getTcareConnectIntakeToken()       // ??? why intake token?
    // };
    const body = {
        'leftServiceIds': reviewIds
    };
    // logRequestInfo(url, body);
    // const json = {errors: 'not implemented yet'};        // test only
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// Create / Update Services (UPSERT)
// POST /intake/upsertservice
export const requestCreateService = async (body) => {
    const url = ENDPOINTS.requestCreateService;
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': getTcareConnectIntakeToken() // ??? why intake token?
    };
    // logRequestInfo(url, body);
    const json = await fetchPost(url, headers, body);
    return json;
};
export const requestCreateService2 = async (body) => {
    const url = ENDPOINTS.requestCreateService;
    // logRequestInfo(url, body);
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// POST /intake/upsertservice (same as above - payload is different)
export const requestUpdateService = async (body) => {
    const url = ENDPOINTS.requestUpdateService;
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': getTcareConnectIntakeToken() // ??? why intake token?
    };
    // logRequestInfo(url, body);
    const json = await fetchPost(url, headers, body);
    return json;
};
export const requestUpdateService2 = async (body) => {
    const url = ENDPOINTS.requestUpdateService;
    let headers = null;
    // logRequestInfo(url, body);
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// POST /api/v1/rest/services/bulk
// { "size": 100 }    
export const fetchBulkServices = async (idsArray) => {
    const url = ENDPOINTS.fetchBulkServices;
    const headers = null;
    const body = {
        'ids': idsArray
    };
    // logRequestInfo(url, body);
    const json = await fetchPost(url, headers, body);
    return json;
};
export const fetchBulkServices2 = async (idsArray) => {
    const url = ENDPOINTS.fetchBulkServices;
    const headers = null;
    const body = {
        'ids': idsArray
    };
    // logRequestInfo(url, body);
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, headers, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// 06/03 - need public non-auth calls for public Landing Page:
// 06-23 - actual APIs for the non-auth public calls
// publicSearchServices:       bindings.tcareConnectApi + '/api/public/v1/rpc/search',
// publicFetchServiceById:     bindings.tcareConnectApi + '/api/public/v1/rest/services/',
// publicFetchTaxonomies:      bindings.tcareConnectApi + '/api/public/v1/rpc/taxonomy-forest',
// POST http://localhost:3000/api/public/v1/rpc/search/
export const publicSearchServices = async (searchBody) => {
    const url = ENDPOINTS.publicSearchServices;
    const headers = null;
    // logRequestInfo(url, searchBody);
    const json = await fetchPost(url, headers, searchBody);
    return json; // may be an error
};
export const publicSearchServices2 = async (searchBody) => {
    const url = ENDPOINTS.publicSearchServices;
    const headers = null;
    let json = await fetchJson(METHOD.POST, url, headers, searchBody, null)
        .catch(err => {
        console.error('publicSearchServices2 TCARE internal fetch error: ', err);
        // return {errors: [{message: 'Exception thrown while fetching data.'}]};
        return { errors: [{ message: err }] };
    });
    return normalized(json);
};
// GET http://127.0.0.1:3000/api/public/v1/rest/services/:id
export const publicFetchServiceById = async (id) => {
    const url = ENDPOINTS.publicFetchServiceById + id;
    // logRequestInfo(url);
    const json = await fetchGet(url);
    return json; // may be an error
};
export const publicFetchServiceById2 = async (id) => {
    // console.log('publicFetchServiceById2');
    const url = ENDPOINTS.publicFetchServiceById + id;
    // logRequestInfo(url);
    let json = await fetchJson(METHOD.GET, url, null, null, null)
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// GET http://127.0.0.1:3000/api/public/v1/rpc/taxonomy-forest
export const publicFetchTaxonomies = async () => {
    const url = ENDPOINTS.publicFetchTaxonomies;
    // logRequestInfo(url);
    const json = await fetchGet(url);
    if (json[OPEN_ELIG_2022]) {
        json[OPEN_ELIG_2022] = dedupeArray(json[OPEN_ELIG_2022], 'label');
    }
    return json;
};
export const publicFetchTaxonomies2 = async () => {
    const url = ENDPOINTS.publicFetchTaxonomies;
    // logRequestInfo(url);
    let json = normalized(await fetchJson(METHOD.GET, url, null, null, null)
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    }));
    if (json[OPEN_ELIG_2022]) {
        json[OPEN_ELIG_2022] = dedupeArray(json[OPEN_ELIG_2022], 'label');
    }
    return json;
};
export const addServicesToCollection = async (userId, serviceIds, collName) => {
    const url = ENDPOINTS.addServicesToCollection;
    const body = {
        userId: userId,
        serviceIds: serviceIds,
        collectionName: collName
    };
    // logRequestInfo(url, body);
    const json = {};
    // const json = await fetchGet(url);
    // console.log('addServicesToCollection raw json:')
    // console.log(json)
    // json = {error: "could not add to Collections"}       // fake error for testing
    return json;
};
//todo -vjm
export const addServicesToCollection2 = async (userId, serviceIds, collName) => {
    const url = ENDPOINTS.addServicesToCollection;
    const body = {
        userId: userId,
        serviceIds: serviceIds,
        collectionName: collName
    };
    // logRequestInfo(url, body);
    let json = await fetchJson(METHOD.POST, url, null, body, null)
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
export const fetchUserCollections = async (userId) => {
    const url = ENDPOINTS.fetchUserCollections;
    const body = userId;
    // logRequestInfo(url, body);
    const json = FAKE_COLLECTIONS;
    // const json = await fetchGet(url);
    // console.log('fetchUserCollections raw json:')
    // console.log(json)
    return json;
};
//todo -vjm
export const fetchUserCollections2 = async (userId) => {
    const url = ENDPOINTS.fetchUserCollections;
    const body = userId;
    // logRequestInfo(url, body);
    const json = FAKE_COLLECTIONS;
    // const json = await fetchGet(url);
    // console.log('fetchUserCollections raw json:')
    // console.log(json)
    return json;
};
// 09/01 - populate field defaul values - pass in endpoint e.g. 'supported-languages'
export const fetchFieldPresetValues = async (endpoint) => {
    const url = ENDPOINTS.fetchFieldPresetValues + endpoint;
    // logRequestInfo(url);
    // const json = await fetchGet(url);
    const json = await fetchGetWithToken(url);
    return json;
};
export const fetchFieldPresetValues2 = async (endpoint) => {
    // console.log('fetchFieldPresetValues2: ', endpoint)
    const url = ENDPOINTS.fetchFieldPresetValues + endpoint;
    // logRequestInfo(url);
    // const json = await fetchGet(url);
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// new 10/27/2022 - Notes and Ratings API
// NOTES
export const fetchNotes = async () => {
    const url = ENDPOINTS.fetchNotes;
    logRequestInfo(url);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching notes.' }] };
    });
    return normalized(json);
};
export const createNote = async (note) => {
    const url = ENDPOINTS.createNote;
    const body = note;
    logRequestInfo(url, body);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while creating note.' }] };
    });
    return normalized(json);
};
export const updateNote = async (note) => {
    const url = ENDPOINTS.updateNote;
    const body = note;
    logRequestInfo(url, body);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while updating note.' }] };
    });
    return normalized(json);
};
export const deleteNote = async (note) => {
    const url = ENDPOINTS.deleteNote;
    const body = note;
    logRequestInfo(url, body);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while deleting note.' }] };
    });
    return normalized(json);
};
// RATINGS
export const fetchRatings = async () => {
    const url = ENDPOINTS.fetchRatings;
    logRequestInfo(url);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
export const createRating = async (rating) => {
    const url = ENDPOINTS.createRating;
    const body = rating;
    logRequestInfo(url, body);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while creating rating.' }] };
    });
    return normalized(json);
};
export const updateRating = async (rating) => {
    const url = ENDPOINTS.updateRating;
    const body = rating;
    logRequestInfo(url, body);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while updating rating.' }] };
    });
    return normalized(json);
};
export const deleteRating = async (rating) => {
    const url = ENDPOINTS.deleteRating;
    const body = rating;
    logRequestInfo(url, body);
    return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while deleting rating.' }] };
    });
    return normalized(json);
};
// REFERRALS
export const fetchReferralByServiceId = async () => {
    const url = ENDPOINTS.fetchReferralByServiceId;
    logRequestInfo(url);
    //return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
export const publicFetchReferralByServiceId = async () => {
    const url = ENDPOINTS.publicFetchReferralByServiceId;
    logRequestInfo(url);
    //return {};
    let json = await getAPIToken(APIs.connectIntakeAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
// 11/24 - SAVED SERVICES
export const fetchSavedServices = async () => {
    const url = ENDPOINTS.savedServices;
    // logRequestInfo(url);
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.GET, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
export const addSavedServices = async (serviceIds) => {
    const url = ENDPOINTS.savedServices;
    const body = { 'ids': serviceIds };
    // logRequestInfo(url, body);
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.POST, url, null, body, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
export const deleteSavedService = async (serviceId) => {
    const url = ENDPOINTS.savedServices + "/" + serviceId;
    console.log(METHOD.DELETE);
    // logRequestInfo(url);
    let json = await getAPIToken(APIs.connectAPI)
        .then(handleToken)
        .then(token => fetchJson(METHOD.DELETE, url, null, null, token))
        .catch(err => {
        console.error('TCARE internal fetch error: ', err);
        return { errors: [{ message: 'Exception thrown while fetching data.' }] };
    });
    return normalized(json);
};
